import styled from 'styled-components';
import { Divider, Flex } from 'antd';

export const MobileDivider = styled(Divider)`
  display: none;
  @media (max-width: 768px) {
    display: block;
    margin: 8px 0;
  }
`;

export const StyledStepWrapper = styled(Flex)`
  flex-direction: column;
  margin-top: 32px;

  h2 {
    margin: 0;
  }
  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;
